import React from 'react';
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth, ProtectedRoute } from "@/context/AuthContext";
import { ThemeProvider } from "@/context/ThemeContext";
import NavBar from "@/components/NavBar";
import LoginScreen from "@/pages/LoginScreen";
import RegisterScreen from "@/pages/RegisterScreen";
import ForgotPasswordScreen from "@/pages/ForgotPasswordScreen";
import ResetPasswordScreen from "@/pages/ResetPasswordScreen";
import HomeScreen from "@/pages/HomeScreen";
import ClientsScreen from "@/pages/ClientsScreen";
import AddClientScreen from "@/pages/AddClientScreen";
import ClientDetailScreen from "@/pages/ClientDetailScreen";
import BookLessonScreen from "@/pages/BookLessonScreen";
import CalendarScreen from "@/pages/CalendarScreen";
import PackagesScreen from "@/pages/PackagesScreen";
import SettingsScreen from "@/pages/SettingsScreen";
import SubscriptionScreen from "@/pages/SubscriptionScreen";

const AppContent = () => {
  const { user, loading } = useAuth();
  
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-100 dark:bg-gray-900">
        <div className="text-center">
          <div className="text-4xl mb-4">💪</div>
          <div className="text-gray-500 dark:text-gray-400">Caricamento...</div>
        </div>
      </div>
    );
  }
  
  return (
    <>
      <Routes>
        <Route path="/login" element={user ? <Navigate to="/" replace /> : <LoginScreen />} />
        <Route path="/register" element={user ? <Navigate to="/" replace /> : <RegisterScreen />} />
        <Route path="/forgot-password" element={user ? <Navigate to="/" replace /> : <ForgotPasswordScreen />} />
        <Route path="/reset-password" element={user ? <Navigate to="/" replace /> : <ResetPasswordScreen />} />
        
        <Route path="/" element={<ProtectedRoute><HomeScreen /></ProtectedRoute>} />
        <Route path="/clienti" element={<ProtectedRoute><ClientsScreen /></ProtectedRoute>} />
        <Route path="/nuovo-cliente" element={<ProtectedRoute><AddClientScreen /></ProtectedRoute>} />
        <Route path="/cliente/:id" element={<ProtectedRoute><ClientDetailScreen /></ProtectedRoute>} />
        <Route path="/prenota/:clientId?" element={<ProtectedRoute><BookLessonScreen /></ProtectedRoute>} />
        <Route path="/calendario" element={<ProtectedRoute><CalendarScreen /></ProtectedRoute>} />
        <Route path="/pacchetti" element={<ProtectedRoute><PackagesScreen /></ProtectedRoute>} />
        <Route path="/impostazioni" element={<ProtectedRoute><SettingsScreen /></ProtectedRoute>} />
        <Route path="/abbonamento" element={<ProtectedRoute><SubscriptionScreen /></ProtectedRoute>} />
        
        <Route path="*" element={<Navigate to={user ? "/" : "/login"} replace />} />
      </Routes>
      {user && <NavBar />}
    </>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ThemeProvider>
          <AuthProvider>
            <AppContent />
          </AuthProvider>
        </ThemeProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
